const translations = {
    emailAddressFieldPlaceholder: 'Email',
    invite: 'INVITE'
};

export default translations;
